module.exports = __webpack_public_path__ + "static/media/footer-icon-bucket.d09f50c4.svg";